
// panel-wrapper.component.ts
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { FieldWrapper } from '@ngx-formly/core';
import PrettySequenceHelper from '../../../shared/form-builder-util/pretty-sequence';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Config } from 'src/app/config';
import { PermissionsService } from 'src/app/services/auth/permissions.service';
import { ActionsEnum } from 'src/app/enums/permissions/actions.enum';
import { WidgetsFieldModel } from 'src/app/models/widgets/widgets-field.model';
import { keyOverrideService } from 'src/app/services/workflow/keyOverrideService.service';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'formly-field-wrapper',
  templateUrl: './widgets-field-wrapper.component.html',
  styleUrls: ['./widgets-field-wrapper.component.scss']
})
export class WidgetsFieldWrapperComponent extends FieldWrapper implements OnInit {
  // A variable called to is automatically exposed as part of the FieldWrapper extended class
  // Meaning: props
  // All attributes defined as template options can be read like that (to.sequence, to.label,...)
  @ViewChild('fieldWrapperDialog') templateRefConfirmation?: ElementRef;
  modalRefConf: BsModalRef = new BsModalRef();
  fieldWrapperShown: boolean = false;
  data: WidgetsFieldModel =  new WidgetsFieldModel();
  layoutRoot = this.widgetsService_.getLayoutRoot();
  formId;
  isKeyVisible:boolean = false;
  iskeyOverwritePossible;

  constructor(
    public modalService: BsModalService,
    private permissionService: PermissionsService,
    private widgetsService_: WidgetsService,
    private keyOverrideService_:keyOverrideService,
    private route: ActivatedRoute,
    private router_:Router
  ) {
    super();
  }

  ngOnInit(): void {
    this.keyOverrideService_.isKeyOverWritePossible$.subscribe(flag=>{
      this.iskeyOverwritePossible = flag;
    });
    if(this.router_.url.includes('preview')){
      this.isKeyVisible = true
    }
    this.fieldWrapperShown = this.permissionService.hasUserPermission(ActionsEnum.fieldWrapper);

    // NOTE: We use a FieldsModel with just to store the keys...
    if (this.field.key) {
      const myKey = this.field.key;
      // this.data.key = this.field.key;

      // TODO: Decide where to render fdKey/isoKey
      // this.data.fdKey = this.field.fdKey;
    } else if (this.field.fieldGroup && this.field.fieldGroup.length) {
      this.field.fieldGroup.forEach((fld) => {
        if (fld.key) {
          if (fld.key && fld.type == 'uw-multicheckbox'  ) { // for checkbox 
            let field_:any= this.field.fieldGroup;
            this.data.key = field_[1].key ;
          } 
          else if (fld.type == 'uw-radio' || fld.type == 'uw-input' && fld.className !== 'prop-comment-checkbox') { // for radio and input
            this.data.key = fld.key as string;
          } 
          this.data.isEdit = true;
        } 
      });
    }

    this.route.queryParams.subscribe((params) => {
      this.formId = params.id;
    });
  }

  /**
   * this method will run on Override button click
   * **/ 
  OverrideKey(){
   let updatedRoot = this.keyOverrideService_.applyKeyOverride(this.layoutRoot, this.data.fdKey, this.data.key);
   this.widgetsService_.setLayoutRoot(updatedRoot);

  // Save the form forcely in DB after seting the root  
   setTimeout(()=>{this.keyOverrideService_.saveForm()},2000)
  }

  

  openFieldWrapperDialog() {
    this.modalRefConf = this.modalService.show(this.templateRefConfirmation);
  }
}
